export default __webpack_public_path__ + "static/media/insta.853d0759.svg";